
import { Media } from 'reactstrap';
import '../../App.css';
import Footer from '../../components/footer';
import Main from '../../components/main-section';

export const Inicio = () => {
         
    return (
<div className="App">
      <Main />
      <Footer/>
    </div>
 )
}
